import { createSlice } from '@reduxjs/toolkit';

export const uiSliceKey = 'ui';

const initialState = {
  isModalSubcontractVisible: false,
  isModalTagsVisible: false
};

const { actions, reducer } = createSlice({
  name: uiSliceKey,
  initialState,
  reducers: {
    // Acciones para el modal de subcontract
    showSubcontractModal(state) {
      state.isModalSubcontractVisible = true;
    },
    hideSubcontractModal(state) {
      state.isModalSubcontractVisible = false;
    },
    toggleSubcontractModal(state) {
      state.isModalSubcontractVisible = !state.isModalSubcontractVisible;
    },

    // Acciones para el modal de tags
    showTagsModal(state) {
      state.isModalTagsVisible = true;
    },
    hideTagsModal(state) {
      state.isModalTagsVisible = false;
    },
    toggleTagsModal(state) {
      state.isModalTagsVisible = !state.isModalTagsVisible;
    }
  }
});

// Selectores
export const getIsModalSubcontractVisible = (state) =>
  state[uiSliceKey].isModalSubcontractVisible;
export const getIsModalTagsVisible = (state) =>
  state[uiSliceKey].isModalTagsVisible;

// Exportaciones
export const uiReducer = reducer;
export const {
  showSubcontractModal,
  hideSubcontractModal,
  toggleSubcontractModal,
  showTagsModal,
  hideTagsModal,
  toggleTagsModal
} = actions;
